// extracted by mini-css-extract-plugin
export default {"formField":"default_formField__VbmQO","label":"default_label__hu1-M","switchLabel":"default_switchLabel__AP0me"};